<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="650px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Holiday Detail"
      text="Assign Holiday Detail to State"
      class="mb-0"
    >
      <form
        v-if="dialog"
        ref="detailStateUpdateForm"
      >
        <v-container>
          <v-row>
            <v-col
              cols="6"
              class="pb-0"
            >
              <v-autocomplete
                v-model="holidayDetail.holiday.id"
                v-validate="'required'"
                disabled
                prepend-icon="event"
                :error-messages="errors.collect('holiday')" 
                data-vv-name="holiday"
                :items="holidays"
                item-text="name"
                item-value="id"
                label="Holiday"
              />
            </v-col>

            <v-col
              cols="6"
            >
              <v-menu
                id="date"
                v-model="datemenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="selectedDateDisplay"
                    v-validate="'required'"
                    label="Holiday Date"
                    :error-messages="errors.collect('date')" 
                    data-vv-name="date"
                    readonly
                    outlined
                    class="label-position"
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="form.date"
                  :min="earliestDate"
                  :max="latestDate"
                  class="datepicker"
                  no-title
                  @input="datemenu = false"
                />
              </v-menu>              
            </v-col>
          </v-row>          

          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <span class="font-weight-bold bold">  State & Departments:</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div
                class="selection"
                data-simplebar
              >
                <v-treeview
                  v-model="selectedStateDepartments"
                  :items="stateDepartments"
                  selectable
                  dense
                  open-all
                  return-object
                />
              </div>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-btn @click="selectDeselect">
          Select/Deselect All
        </v-btn>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          class="px-10"     
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"     
          class="px-10 white--text"     
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      holidayDetail: {
        type: Object,
        default: null,
      },
      states: {
        type: Array,
        default: () => {
          return []
        },
      }, 
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        holidays: [],
        datemenu: false,
        form: {
          date: null,
        },
        selectedStateDepartments: [],
        stateDepartments: [],
      }
    },
    computed: {
      earliestDate () {
        return this.$moment().year() + '-01-01'
      },
      latestDate () {
        return this.$moment().year() + 1 + '-12-31'
      },
      selectedDateDisplay () {
        return this.$moment(this.form.date, 'YYYY-MM-DD').format('D MMM YYYY') 
      },
    },
    watch: {
      dialog: function (value) {
        if (value) {
          this.loadData()

          this.form.date = this.holidayDetail.date
        } else {
          if (this.$refs.detailStateUpdateForm) {
            this.$refs.detailStateUpdateForm.reset()
          }
        }
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisHolidayDetails().update(this.holidayDetail.id, this.prepareFormData())
              .then((response) => {
                if (response.status === 200) {
                  this.dialog = false
                  this.$emit('updated')
                  this.$snack({ message: 'Holiday detail updated' })
                }
              })
              .catch(() => {                  
                this.$snack({ 
                  color: 'error',
                  message: 'Error update holiday detail', 
                })
              })
              .then(() => {
                this.setProgressing(false)
              })
          })
      },       
      loadData () {
        this.$http.all([
          this.$api.hrisHolidays().list(),
          this.$api.hrisDepartments().list(),
        ])
          .then(this.$http.spread((holidays, departments) => {
            let selectedStatesDepartments = []

            this.holidays = holidays.data

            this.stateDepartments = this.states
            this.stateDepartments.map(item => {
              item.children = this.formatDepartments(item.id, JSON.parse(JSON.stringify(departments.data)))
            })

            this.holidayDetail.holiday_states.map(item => {
              selectedStatesDepartments.push({ 'id': item.department_id + '-' + item.state_id, 'name': item.department.name, 'state_id': item.state_id })
            })

            this.selectedStateDepartments = selectedStatesDepartments
          }))
      },    
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          ...this.form,
          state_departments: this.prepareStateDepartmentsFormData(),
        }
      },
      prepareStateDepartmentsFormData () {
        let finalData = []
        _.chain(this.selectedStateDepartments)
          .groupBy('state_id')
          .map((value, key) => {
            finalData.push({
              states: key,
              departments: this.getDepartmentIds(value),
            })
          })
          .value()
        return finalData
      },

      formatDepartments (id, departments) {
        departments.map(department => {
          department.id = department.id + '-' + id
          department.state_id = id
        })
 
        return departments
      },

      getDepartmentIds (value) {
        let ids = []
   
        value.map(item => {
          ids.push(item.id.substring(0, item.id.indexOf('-')))
        })
        return ids
      },

      selectDeselect () {
        if (this.selectedStateDepartments.length > 0) {
          this.selectedStateDepartments = []
        } else { 
          let allSelections = []
        
          this.stateDepartments.map(item => {
            item.children.map(item2 => {
              allSelections.push(item2)
            })
          })

          this.selectedStateDepartments = allSelections
        }
      },
    },
  }
</script>

<style lang="css" scoped>
  .bold{
    font-size:20px
  }

  .selection{
    height: 400px;
    overflow-y: scroll
    }

 ::-webkit-scrollbar {
    width: 0px;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
  }

  .label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  padding-right:5px;
  background:white
}
</style>
